export const firebaseConfig = {
  apiKey: "AIzaSyAvPB724ldXS0vZ5Mb3qO8U3Aad911QDmk",
  authDomain: "projectxope2023.firebaseapp.com",
  projectId: "projectxope2023",
  storageBucket: "projectxope2023.appspot.com",
  messagingSenderId: "347230062817",
  appId: "1:347230062817:web:64141d10ca4204c7b3cfa0",
  measurementId: "G-7HP4RMBVB5",
};
